import { get } from "@services/apiService.js";

export default {
  // Manager
  getCategories(lang) {
    return get(`/v4/content-manager/v1/categories`, { language: lang })
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
  getContent(options = {}) {
    return get(`/v4/content-manager/v1/contents`, options)
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },

  // Web
  getWebCategories(lang) {
    return get(`/v4/content-web/v1/categories`, { language: lang })
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
  getCategoriesCheck(lang) { // will delete
    return get(`/v4/content-web/v1/categories`, { language: lang })
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
  getContentByCate(options = {}) {
    return get(`/v4/content-web/v1/contents`, options)
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
  getContentDetail(options = {}) {
    return get(`/v4/content-web/v1/content/detail`, options)
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
  getContentRelate(options = {}) {
    return get(`/v4/content-web/v1/contentRelateds`, options)
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  }
}